import { render, staticRenderFns } from "./HeadLayout.vue?vue&type=template&id=8c97a5f6&"
import script from "./HeadLayout.vue?vue&type=script&lang=js&"
export * from "./HeadLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports